export const AUTH_TOKEN = 'admin_token'